import { render, staticRenderFns } from "./assessmentConfTable.vue?vue&type=template&id=42fb04f0&scoped=true&"
import script from "./assessmentConfTable.vue?vue&type=script&lang=js&"
export * from "./assessmentConfTable.vue?vue&type=script&lang=js&"
import style0 from "./assessmentConfTable.vue?vue&type=style&index=0&id=42fb04f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb04f0",
  null
  
)

export default component.exports